module.exports = __webpack_public_path__ + "static/aboutus-3-min-ac34c5989276a439cba04f761616a8d4.webp";